module.exports = __webpack_public_path__ + "static/media/twitter.90df6536.svg";